// Brand assets for Brain Superheroes Wellness App
export const BRAND_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_adae1bdd-4baf-4d67-97e5-2a601525f891/artifacts/7wrh3e55_file_000000006e4471f58bb9ff1e146a77e7.png";
